import { cn } from "@/lib/utils";

export interface MetricItem {
  label: string;
  value: string | number;
  tone?: "default" | "amber" | "lime";
}

export function MetricBand({
  eyebrow,
  title,
  items,
  className,
}: {
  eyebrow?: string;
  title?: string;
  items: MetricItem[];
  className?: string;
}) {
  return (
    <section className={cn("mb-6", className)}>
      {(eyebrow || title) && (
        <div className="mb-3">
          {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
          {title ? (
            <h2 className="tl-title" style={{ fontSize: "clamp(1.2rem, 2vw, 1.55rem)" }}>
              {title}
            </h2>
          ) : null}
        </div>
      )}
      <div
        className="grid border border-[color:var(--hairline)] bg-[color:var(--bg-elev)]"
        style={{
          gridTemplateColumns: `repeat(${Math.min(items.length, 4)}, minmax(0, 1fr))`,
        }}
      >
        {items.map((it, i) => (
          <div
            key={it.label}
            className={cn(
              "px-3.5 py-3",
              i < items.length - 1 && "border-r border-[color:var(--hairline)]",
            )}
          >
            <span className="mb-1 block font-mono text-[0.58rem] font-medium uppercase tracking-[0.1em] text-[color:var(--faint)]">
              {it.label}
            </span>
            <span
              className={cn(
                "block font-mono text-[1.35rem] font-medium leading-none tracking-[-0.04em]",
                it.tone === "amber" && "text-[color:var(--accent)]",
                it.tone === "lime" && "text-[color:var(--lime)]",
                (!it.tone || it.tone === "default") && "text-[color:var(--text)]",
              )}
            >
              {it.value}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
